import { YaysonStore } from './yayson.store'

export class Store extends YaysonStore {

  /**
   * Monkey-patched version of super#toModel(), that will - non-invasively - let yayson return the type
   * of the object that has been retrieved from a JSON-API endpoint, so that we can use this information
   * to determine the correct class to instantiate our angular models accordingly
   *
   * @Override
   */
  public toModel(rec, type, models) {
    const typeCanBeAddedToRecord = rec.attributes && rec.attributes instanceof Object
    if (typeCanBeAddedToRecord) {
      rec.attributes['type'] = rec.type
    }
    const superModel = super.toModel(rec, type, models)

    if (typeCanBeAddedToRecord) {
      delete rec.attributes['type']
    }
    delete superModel.link
    return superModel
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/json-api-backend/yayson/store.ts